// setEnvHDR.ts
import * as THREE from 'three'
import type {Texture } from 'three'
//import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import { HDRLoader } from 'three/examples/jsm/loaders/HDRLoader.js'


export default async function initEnvironment(threeViewer: any, url: string): Promise<Texture | null> {
    try {
        const scene = threeViewer.scene as THREE.Scene
        const renderer = threeViewer.renderer as THREE.WebGLRenderer
        const pmrem = new THREE.PMREMGenerator(renderer)
        const hdr = await new HDRLoader().loadAsync(url)
        const tex = pmrem.fromEquirectangular(hdr).texture
        scene.environment = tex
        scene.background = null
        hdr.dispose()
        pmrem.dispose()
        return tex
    } catch (e) {
        console.warn('HDR load failed:', e)
        return null
    }
}